// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { APP } from '../../../../../com/MetaPattern/MDA/MD/Base/APP';
import { WorkScope } from '../../../../../com/MetaPattern/MDA/MD/Base/WorkScope';
import { BEComponent } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { Product } from '../../../../../com/MetaPattern/MDA/MD/Base/Product';
import { APPComponent } from '../../../../../com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { UIModelComponent } from '../../../../../com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { EntityAttributesDTO } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EntityAttributesDTO';
import { DBComponent } from '../../../../../com/MetaPattern/MDA/MD/DBModel/DBComponent';
import { AttachmentFile } from '../../../../../com/MetaPattern/MDA/MD/Base/AttachmentFile';
import { get, post } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
class SaveBEComponentDTO {
  component: BEComponent;

  public toJson(): any {
    const json: any = {};
    if (this.component.toJson) {
      json.Component = this.component.toJson();
    } else {
      json.Component = this.component;
    }
    return json;
  }
}
class SaveAPPComponentDTO {
  component: APPComponent;

  public toJson(): any {
    const json: any = {};
    if (this.component.toJson) {
      json.Component = this.component.toJson();
    } else {
      json.Component = this.component;
    }
    return json;
  }
}
class SaveAPPDTO {
  aPP: APP;

  public toJson(): any {
    const json: any = {};
    if (this.aPP.toJson) {
      json.APP = this.aPP.toJson();
    } else {
      json.APP = this.aPP;
    }
    return json;
  }
}
class SaveUIModelComponentDTO {
  component: UIModelComponent;

  public toJson(): any {
    const json: any = {};
    if (this.component.toJson) {
      json.Component = this.component.toJson();
    } else {
      json.Component = this.component;
    }
    return json;
  }
}
class BEToUIModelDTO {
  bEComponentID: string;

  public toJson(): any {
    const json: any = {};
    json.BEComponentID = this.bEComponentID;
    return json;
  }
}
class BEToDBDTO {
  bEComponentID: string;

  public toJson(): any {
    const json: any = {};
    json.BEComponentID = this.bEComponentID;
    return json;
  }
}
class APPConvertToDBDTO {
  aPP: APP;

  public toJson(): any {
    const json: any = {};
    if (this.aPP.toJson) {
      json.APP = this.aPP.toJson();
    } else {
      json.APP = this.aPP;
    }
    return json;
  }
}
class APPConvertToUIDTO {
  aPP: APP;

  public toJson(): any {
    const json: any = {};
    if (this.aPP.toJson) {
      json.APP = this.aPP.toJson();
    } else {
      json.APP = this.aPP;
    }
    return json;
  }
}
class GenerateBEComponentDTO {
  requirement: string;

  public toJson(): any {
    const json: any = {};
    json.requirement = this.requirement;
    return json;
  }
}
/**
 * 元数据服务 服务类
 * 定义元数据相关服务
 */
export class MDService {
  static async GetAllAPPAsync(aPPKey: string): Promise<Array<APP> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getallapp', { aPPKey: aPPKey })
        .then((response: any) => {
          let result: Array<APP> | null = null;
          if (response) {
            const items = new Array<APP>();
            response.forEach((item: any) => {
              const element = APP.Create(item);
              if (item.WorkScope !== null) {
                element.workScope = WorkScope.Create(item.WorkScope);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetFullBEComponentAsync(iD: string): Promise<BEComponent | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getfullbecomponent', { iD: iD })
        .then((response: any) => {
          let result: BEComponent | null = null;
          if (response) {
            result = BEComponent.Create(response);
            if (response.APP !== null) {
              result.aPP = APP.Create(response.APP);
            }
            if (response.Product !== null) {
              result.product = Product.Create(response.Product);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async InitDataAsync(): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/initdata')
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async SaveBEComponentAsync(component: BEComponent): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveBEComponentDTO();
      dto.component = component;
      post('metapattern-ide-mmdapp/service/mdservice/savebecomponent', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async MVPInitDataAsync(): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/mvpinitdata')
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async SaveAPPComponentAsync(component: APPComponent): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveAPPComponentDTO();
      dto.component = component;
      post('metapattern-ide-mmdapp/service/mdservice/saveappcomponent', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async SaveAPPAsync(aPP: APP): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveAPPDTO();
      dto.aPP = aPP;
      post('metapattern-ide-mmdapp/service/mdservice/saveapp', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetFullAPPComponentAsync(iD: string): Promise<APPComponent | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getfullappcomponent', { iD: iD })
        .then((response: any) => {
          let result: APPComponent | null = null;
          if (response) {
            result = APPComponent.Create(response);
            if (response.APP !== null) {
              result.aPP = APP.Create(response.APP);
            }
            if (response.Product !== null) {
              result.product = Product.Create(response.Product);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetFullAPPAsync(aPPKey: string, includeComponentTypes: number): Promise<APP | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getfullapp', { aPPKey: aPPKey, includeComponentTypes: includeComponentTypes })
        .then((response: any) => {
          let result: APP | null = null;
          if (response) {
            result = APP.Create(response);
            if (response.WorkScope !== null) {
              result.workScope = WorkScope.Create(response.WorkScope);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetFullUIModelComponentAsync(iD: string): Promise<UIModelComponent | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getfulluimodelcomponent', { iD: iD })
        .then((response: any) => {
          let result: UIModelComponent | null = null;
          if (response) {
            result = UIModelComponent.Create(response);
            if (response.APP !== null) {
              result.aPP = APP.Create(response.APP);
            }
            if (response.Product !== null) {
              result.product = Product.Create(response.Product);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async SaveUIModelComponentAsync(component: UIModelComponent): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveUIModelComponentDTO();
      dto.component = component;
      post('metapattern-ide-mmdapp/service/mdservice/saveuimodelcomponent', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async BEToUIModelAsync(bEComponentID: string): Promise<UIModelComponent | null> {
    return new Promise((resolve, reject) => {
      const dto = new BEToUIModelDTO();
      dto.bEComponentID = bEComponentID;
      post('metapattern-ide-mmdapp/service/mdservice/betouimodel', dto.toJson())
        .then((response: any) => {
          let result: UIModelComponent | null = null;
          if (response) {
            result = UIModelComponent.Create(response);
            if (response.APP !== null) {
              result.aPP = APP.Create(response.APP);
            }
            if (response.Product !== null) {
              result.product = Product.Create(response.Product);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetAllAttributesAsync(entityID: string): Promise<EntityAttributesDTO | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getallattributes', { entityID: entityID })
        .then((response: any) => {
          let result: EntityAttributesDTO | null = null;
          if (response) {
            result = EntityAttributesDTO.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetInfrastructureAPPAsync(): Promise<APP | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getinfrastructureapp')
        .then((response: any) => {
          let result: APP | null = null;
          if (response) {
            result = APP.Create(response);
            if (response.WorkScope !== null) {
              result.workScope = WorkScope.Create(response.WorkScope);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async BEToDBAsync(bEComponentID: string): Promise<DBComponent | null> {
    return new Promise((resolve, reject) => {
      const dto = new BEToDBDTO();
      dto.bEComponentID = bEComponentID;
      post('metapattern-ide-mmdapp/service/mdservice/betodb', dto.toJson())
        .then((response: any) => {
          let result: DBComponent | null = null;
          if (response) {
            result = DBComponent.Create(response);
            if (response.BindingBEComponent !== null) {
              result.bindingBEComponent = BEComponent.Create(response.BindingBEComponent);
            }
            if (response.APP !== null) {
              result.aPP = APP.Create(response.APP);
            }
            if (response.Product !== null) {
              result.product = Product.Create(response.Product);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async APPConvertToDBAsync(aPP: APP): Promise<Array<DBComponent> | null> {
    return new Promise((resolve, reject) => {
      const dto = new APPConvertToDBDTO();
      dto.aPP = aPP;
      post('metapattern-ide-mmdapp/service/mdservice/appconverttodb', dto.toJson())
        .then((response: any) => {
          let result: Array<DBComponent> | null = null;
          if (response) {
            const items = new Array<DBComponent>();
            response.forEach((item: any) => {
              const element = DBComponent.Create(item);
              if (item.BindingBEComponent !== null) {
                element.bindingBEComponent = BEComponent.Create(item.BindingBEComponent);
              }
              if (item.APP !== null) {
                element.aPP = APP.Create(item.APP);
              }
              if (item.Product !== null) {
                element.product = Product.Create(item.Product);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async APPConvertToUIAsync(aPP: APP): Promise<Array<UIModelComponent> | null> {
    return new Promise((resolve, reject) => {
      const dto = new APPConvertToUIDTO();
      dto.aPP = aPP;
      post('metapattern-ide-mmdapp/service/mdservice/appconverttoui', dto.toJson())
        .then((response: any) => {
          let result: Array<UIModelComponent> | null = null;
          if (response) {
            const items = new Array<UIModelComponent>();
            response.forEach((item: any) => {
              const element = UIModelComponent.Create(item);
              if (item.APP !== null) {
                element.aPP = APP.Create(item.APP);
              }
              if (item.Product !== null) {
                element.product = Product.Create(item.Product);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetAPPAttachmentsAsync(aPPKey: string): Promise<Array<AttachmentFile> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getappattachments', { aPPKey: aPPKey })
        .then((response: any) => {
          let result: Array<AttachmentFile> | null = null;
          if (response) {
            const items = new Array<AttachmentFile>();
            response.forEach((item: any) => {
              const element = AttachmentFile.Create(item);
              if (item.APP !== null) {
                element.aPP = APP.Create(item.APP);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetFullAPPByIdAsync(iD: string, includeComponentTypes: number): Promise<APP | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/mdservice/getfullappbyid', { iD: iD, includeComponentTypes: includeComponentTypes })
        .then((response: any) => {
          let result: APP | null = null;
          if (response) {
            result = APP.Create(response);
            if (response.WorkScope !== null) {
              result.workScope = WorkScope.Create(response.WorkScope);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GenerateBEComponentAsync(requirement: string): Promise<BEComponent | null> {
    return new Promise((resolve, reject) => {
      const dto = new GenerateBEComponentDTO();
      dto.requirement = requirement;
      post('metapattern-ide-mmdapp/service/mdservice/generatebecomponent', dto.toJson())
        .then((response: any) => {
          let result: BEComponent | null = null;
          if (response) {
            result = BEComponent.Create(response);
            if (response.APP !== null) {
              result.aPP = APP.Create(response.APP);
            }
            if (response.Product !== null) {
              result.product = Product.Create(response.Product);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
